import React from 'react'
// components
import InjuryMasterMapping from '../InjuryMasterMapping'

interface Props {
  field: string
}

const UpdateCase: React.FC<Props> = ({ field }) => (
  <InjuryMasterMapping
    field={field}
    description="Sends these fields to the record's existing Injury Master incident. It must have been created first."
  />
)

export default UpdateCase
